<div class="row page-header d-flex justify-content-center mx-sm-1">
  <div class="col-12 col-lg-11 col-xl-10 px-0">
    <div
      class="d-flex justify-content-between mb-2 align-items-end px-2 px-sm-0"
    >
      <app-page-title
        [customTitle]="'setMsGraphOptions'"
        [hideDescription]="true"
      ></app-page-title>

      <div style="display: flex; gap: 20px">
        <!-- *ngIf="(generalDataRepo.allGeneralData$ | async)?.chatGPTForTenant" -->
        <p-button
          class="d-none d-sm-block"
          label="{{ 'add' | transloco }}"
          icon="pi pi-plus"
          [routerLink]="['/tenants/emails/new', tenantId]"
        />
      </div>
    </div>
    <div>
      <p-table
        #dt1
        [value]="emailTemplateItems"
        [globalFilterFields]="['title', 'description']"
      >
        <ng-template pTemplate="header">
          <tr>
            <th colspan="2">
              <div class="col-12 col-xl-10">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-search"></i>
                  </p-inputgroup-addon>
                  <input
                    type="text"
                    pInputText
                    (input)="onGlobalFilter(dt1, $event)"
                    placeholder="{{ 'search' | transloco }}"
                  />
                </p-inputgroup>
              </div>
            </th>
            <th class="d-none d-xl-table-cell"></th>
          </tr>
          <tr>
            <th pSortableColumn="title" class="col-xl-4 col-6">
              {{ "name" | transloco }} <p-sortIcon field="title"></p-sortIcon>
            </th>
            <th pSortableColumn="createdAt" class="col-xl-2 col-5">
              {{ "created" | transloco }}
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th class="col-1"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-option>
          <tr>
            <td>
              <p class="text-break splice-text">
                {{ option.title }}
              </p>
            </td>
            <td>
              {{ option.createdAt | date : "dd-MM-YYYY HH:mm" }}
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="toolBoxMenu"
                  tabindex="-1"
                  class="small-icon-button d-flex justify-content-center align-items-center p-0"
                  style="
                    width: 32px;
                    height: 32px;
                    font-size: 20px;
                    line-height: 1;
                  "
                >
                  <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
                </button>
                <mat-menu #toolBoxMenu="matMenu">
                  <button mat-menu-item [routerLink]="[option.id]">
                    {{ "edit" | transloco }}
                  </button>
                  <button
                    mat-menu-item
                    class="text-danger"
                    (click)="deleteConfirmation = option"
                    title="{{ 'delete' | transloco }}"
                  >
                    {{ "delete" | transloco }}
                  </button>
                  <button mat-menu-item (click)="testEmailsOptions(option.id)">
                    {{ "test" | transloco }}
                  </button>
                </mat-menu>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <p class="text-muted px-3 py-2">{{ "noItemsFound" | transloco }}</p>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.title"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>
